import { Box, Stack, Typography, useTheme } from "@mui/material";

interface Props {
  label: string;
  color: string;
}

export default function HomeLegend({ label, color }: Props) {
  const theme = useTheme()
  
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box 
        sx={{
          width: '7px',
          height: '15px',
          background: color,
          border: `1px solid ${theme.palette.divider}`
        }} 
      />
      <Typography fontSize="small">{label}</Typography>
    </Stack>
  )
}